import { Identifiable, Zone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getGanttCalendarRange(httpClient: HttpClient) {
  return (zone?: Identifiable<Zone>) =>
    httpClient
      .sendHttpRequest<{
        earliestStartDate: string;
        latestEndDate: string;
      }>({
        endpoint: zone
          ? `/zones/${zone.uuid}/projects/date-range`
          : "/planzones/projects/date-range",
        method: HttpMethods.GET,
      })
      .then(
        (res) => [res.earliestStartDate, res.latestEndDate] as [string, string],
      );
}

export { getGanttCalendarRange };
